"use strict";

var _slicedToArray = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

var _keys = require("blockstack/lib/keys");

var _encryption = require("blockstack/lib/encryption");

var _wolfy87Eventemitter = _interopRequireDefault(require("wolfy87-eventemitter"));

var _helpers = require("./helpers");

var _api = require("./api");

var _streamer = _interopRequireDefault(require("./streamer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EVENT_NAME = 'MODEL_STREAM_EVENT';

var Model =
/*#__PURE__*/
function () {
  _createClass(Model, null, [{
    key: "fromSchema",
    value: function fromSchema(schema) {
      this.schema = schema;
      return this;
    }
  }, {
    key: "fetchList",
    value: function () {
      var _fetchList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _selector,
            _ref,
            _ref$decrypt,
            decrypt,
            selector,
            _ref2,
            results,
            Clazz,
            modelDecryptions,
            models,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _selector = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref$decrypt = _ref.decrypt, decrypt = _ref$decrypt === void 0 ? true : _ref$decrypt;
                selector = _objectSpread({}, _selector, {
                  radiksType: this.modelName()
                });
                _context.next = 5;
                return (0, _api.find)(selector);

              case 5:
                _ref2 = _context.sent;
                results = _ref2.results;
                Clazz = this;
                modelDecryptions = results.map(function (doc) {
                  var model = new Clazz(doc);

                  if (decrypt) {
                    return model.decrypt();
                  }

                  return Promise.resolve(model);
                });
                _context.next = 11;
                return Promise.all(modelDecryptions);

              case 11:
                models = _context.sent;
                return _context.abrupt("return", models);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchList() {
        return _fetchList.apply(this, arguments);
      }

      return fetchList;
    }()
  }, {
    key: "findOne",
    value: function () {
      var _findOne = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _selector,
            options,
            selector,
            results,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _selector = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {
                  decrypt: true
                };
                selector = _objectSpread({}, _selector, {
                  limit: 1
                });
                _context2.next = 5;
                return this.fetchList(selector, options);

              case 5:
                results = _context2.sent;
                return _context2.abrupt("return", results[0]);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function findOne() {
        return _findOne.apply(this, arguments);
      }

      return findOne;
    }()
  }, {
    key: "findById",
    value: function () {
      var _findById = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(_id, fetchOptions) {
        var Clazz, model;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Clazz = this;
                model = new Clazz({
                  _id: _id
                });
                return _context3.abrupt("return", model.fetch(fetchOptions));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function findById(_x, _x2) {
        return _findById.apply(this, arguments);
      }

      return findById;
    }()
    /**
     * Fetch all models that are owned by the current user.
     * This only includes 'personally' owned models, and not those created
     * as part of a UserGroup
     *
     * @param {Object} _selector - A query to include when fetching models
     */

  }, {
    key: "fetchOwnList",
    value: function fetchOwnList() {
      var _selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _id = (0, _helpers.userGroupKeys)().personal._id;

      var selector = _objectSpread({}, _selector, {
        signingKeyId: _id
      });

      return this.fetchList(selector);
    }
  }]);

  function Model() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Model);

    _defineProperty(this, "schema", void 0);

    _defineProperty(this, "_id", void 0);

    _defineProperty(this, "attrs", void 0);

    var _this$constructor = this.constructor,
        schema = _this$constructor.schema,
        defaults = _this$constructor.defaults;
    var name = this.modelName();
    this.schema = schema;
    this._id = attrs._id || (0, _v.default)().replace('-', '');
    this.attrs = _objectSpread({}, defaults, attrs, {
      radiksType: name
    });
  }

  _createClass(Model, [{
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new Promise(
                /*#__PURE__*/
                function () {
                  var _ref3 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee4(resolve, reject) {
                    var now, encrypted, gaiaURL;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.prev = 0;

                            if (!_this2.beforeSave) {
                              _context4.next = 4;
                              break;
                            }

                            _context4.next = 4;
                            return _this2.beforeSave();

                          case 4:
                            now = new Date().getTime();
                            _this2.attrs.createdAt = _this2.attrs.createdAt || now;
                            _this2.attrs.updatedAt = now;
                            _context4.next = 9;
                            return _this2.sign();

                          case 9:
                            _context4.next = 11;
                            return _this2.encrypted();

                          case 11:
                            encrypted = _context4.sent;
                            _context4.next = 14;
                            return _this2.saveFile(encrypted);

                          case 14:
                            gaiaURL = _context4.sent;
                            _context4.next = 17;
                            return (0, _api.sendNewGaiaUrl)(gaiaURL);

                          case 17:
                            resolve(_this2);
                            _context4.next = 23;
                            break;

                          case 20:
                            _context4.prev = 20;
                            _context4.t0 = _context4["catch"](0);
                            reject(_context4.t0);

                          case 23:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, null, [[0, 20]]);
                  }));

                  return function (_x3, _x4) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "encrypted",
    value: function encrypted() {
      return (0, _helpers.encryptObject)(this);
    }
  }, {
    key: "saveFile",
    value: function saveFile(encrypted) {
      var userSession = (0, _helpers.requireUserSession)();
      return userSession.putFile(this.blockstackPath(), JSON.stringify(encrypted), {
        encrypt: false
      });
    }
  }, {
    key: "blockstackPath",
    value: function blockstackPath() {
      var path = "".concat(this.modelName(), "/").concat(this._id);
      return path;
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _ref4,
            _ref4$decrypt,
            decrypt,
            query,
            _ref5,
            results,
            _results,
            attrs,
            _args6 = arguments;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref4 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, _ref4$decrypt = _ref4.decrypt, decrypt = _ref4$decrypt === void 0 ? true : _ref4$decrypt;
                query = {
                  _id: this._id
                };
                _context6.next = 4;
                return (0, _api.find)(query);

              case 4:
                _ref5 = _context6.sent;
                results = _ref5.results;
                _results = _slicedToArray(results, 1), attrs = _results[0];
                this.attrs = _objectSpread({}, this.attrs, attrs);

                if (!decrypt) {
                  _context6.next = 11;
                  break;
                }

                _context6.next = 11;
                return this.decrypt();

              case 11:
                _context6.next = 13;
                return this.afterFetch();

              case 13:
                return _context6.abrupt("return", this);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetch() {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _helpers.decryptObject)(this.attrs, this);

              case 2:
                this.attrs = _context7.sent;
                return _context7.abrupt("return", this);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function decrypt() {
        return _decrypt.apply(this, arguments);
      }

      return decrypt;
    }()
  }, {
    key: "update",
    value: function update(attrs) {
      this.attrs = _objectSpread({}, this.attrs, attrs);
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var signingKey, privateKey, contentToSign, _ref6, signature;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.attrs.updatable === false)) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return", true);

              case 2:
                signingKey = this.getSigningKey();
                this.attrs.signingKeyId = this.attrs.signingKeyId || signingKey._id;
                privateKey = signingKey.privateKey;
                contentToSign = [this._id];

                if (this.attrs.updatedAt) {
                  contentToSign.push(this.attrs.updatedAt);
                }

                _ref6 = (0, _encryption.signECDSA)(privateKey, contentToSign.join('-')), signature = _ref6.signature;
                this.attrs.radiksSignature = signature;
                return _context8.abrupt("return", this);

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function sign() {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "getSigningKey",
    value: function getSigningKey() {
      if (this.attrs.userGroupId) {
        var _ref7 = (0, _helpers.userGroupKeys)(),
            userGroups = _ref7.userGroups,
            signingKeys = _ref7.signingKeys;

        var _id = userGroups[this.attrs.userGroupId];
        var privateKey = signingKeys[_id];
        return {
          _id: _id,
          privateKey: privateKey
        };
      }

      return (0, _helpers.userGroupKeys)().personal;
    }
  }, {
    key: "encryptionPublicKey",
    value: function () {
      var _encryptionPublicKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", (0, _keys.getPublicKeyFromPrivate)(this.encryptionPrivateKey()));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function encryptionPublicKey() {
        return _encryptionPublicKey.apply(this, arguments);
      }

      return encryptionPublicKey;
    }()
  }, {
    key: "encryptionPrivateKey",
    value: function encryptionPrivateKey() {
      var privateKey;

      if (this.attrs.userGroupId) {
        var _ref8 = (0, _helpers.userGroupKeys)(),
            userGroups = _ref8.userGroups,
            signingKeys = _ref8.signingKeys;

        privateKey = signingKeys[userGroups[this.attrs.userGroupId]];
      } else {
        privateKey = (0, _helpers.requireUserSession)().loadUserData().appPrivateKey;
      }

      return privateKey;
    }
  }, {
    key: "modelName",
    value: function modelName() {
      var modelName = this.constructor.modelName;
      return modelName.apply(this.constructor);
    }
  }, {
    key: "isOwnedByUser",
    value: function isOwnedByUser() {
      var _this3 = this;

      var keys = (0, _helpers.userGroupKeys)();

      if (this.attrs.signingKeyId === keys.personal._id) {
        return true;
      }

      if (this.attrs.userGroupId) {
        var isOwned = false;
        Object.keys(keys.userGroups).forEach(function (groupId) {
          if (groupId === _this3.attrs.userGroupId) {
            isOwned = true;
          }
        });
        return isOwned;
      }

      return false;
    }
  }, {
    key: "destroy",
    value: function () {
      var _destroy = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.sign();

              case 2:
                return _context10.abrupt("return", (0, _api.destroyModel)(this));

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function destroy() {
        return _destroy.apply(this, arguments);
      }

      return destroy;
    }() // @abstract

  }, {
    key: "beforeSave",
    value: function beforeSave() {} // @abstract

  }, {
    key: "afterFetch",
    value: function afterFetch() {}
  }], [{
    key: "modelName",
    value: function modelName() {
      return this.className || this.name;
    }
  }, {
    key: "addStreamListener",
    value: function addStreamListener(callback) {
      var _this4 = this;

      if (!this.emitter) {
        this.emitter = new _wolfy87Eventemitter.default();
      }

      if (this.emitter.getListeners().length === 0) {
        _streamer.default.addListener(function (args) {
          _this4.onStreamEvent(_this4, args);
        });
      }

      this.emitter.addListener(EVENT_NAME, callback);
    }
  }, {
    key: "removeStreamListener",
    value: function removeStreamListener(callback) {
      this.emitter.removeListener(EVENT_NAME, callback);

      if (this.emitter.getListeners().length === 0) {
        _streamer.default.removeListener(this.onStreamEvent);
      }
    }
  }]);

  return Model;
}();

exports.default = Model;

_defineProperty(Model, "schema", void 0);

_defineProperty(Model, "defaults", {});

_defineProperty(Model, "className", void 0);

_defineProperty(Model, "emitter", void 0);

_defineProperty(Model, "onStreamEvent", function (_this, _ref9) {
  var _ref10 = _slicedToArray(_ref9, 1),
      event = _ref10[0];

  try {
    var data = event.data;
    var attrs = JSON.parse(data);

    if (attrs && attrs.radiksType === _this.modelName()) {
      var model = new _this(attrs);

      if (model.isOwnedByUser()) {
        model.decrypt().then(function () {
          _this.emitter.emit(EVENT_NAME, model);
        });
      } else {
        _this.emitter.emit(EVENT_NAME, model);
      }
    }
  } catch (error) {// console.error(error.message);
  }
});